"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGENT_HOME_UNKNOWN = exports.AGENT_DATA_FOLDER_MESSAGES = exports.DATA_ROOT_CHECK_AGENT_STATES = exports.DATA_ROOT_CHECK_STATUSES = void 0;
exports.DATA_ROOT_CHECK_STATUSES = [
    "ok",
    "missing",
    "not_a_directory",
    "not_listable",
    "error",
];
exports.DATA_ROOT_CHECK_AGENT_STATES = [
    "connected",
    "not_connected",
    "upgrade_required",
];
exports.AGENT_DATA_FOLDER_MESSAGES = {
    notConnected: "Your agent for this run environment is not connected",
    upgradeRequired: "Update the agent on this host to browse folders",
    notChecked: "Not checked because the agent did not answer",
    noRoots: "This run environment has no data folders yet. Its owner can add them in the Data folders card of the run environment.",
    outsideRoots: "This folder is outside the folders allowed for this run environment",
    noLongerAllowed: "This folder is no longer allowed on the run environment",
    missingDirectory: "Every file must name a folder from this run environment's data folders",
    environmentMismatch: "These files name more than one run environment",
    browseTruncated: "Showing the first 5000 entries of this folder",
    folderTooLarge: "This folder has more files than can be added at once; choose a subfolder",
    homeUnknown: "Your agent has not reported its home folder, so folders written with ~ cannot be used. Upgrade or reconnect the agent on this host.",
};
exports.AGENT_HOME_UNKNOWN = "agent_home_unknown";
